module.exports = __webpack_public_path__ + "img/flow-desc4.7041739c.png";